// 作者: Codex

import axios from 'axios'

import type { DeviceDistributionResponse } from '../../types/device-mosquito'
import { resolveApiBaseUrl } from '../../utils/apiBaseUrl'

export interface MiniProgramMapDistributionQuery {
    minLng?: number
    maxLng?: number
    minLat?: number
    maxLat?: number
    zoom?: number
    maxVisibleDevices?: number
    projectIds?: number[]
    regionIds?: number[]
    deviceIds?: string[]
    pestTypes?: string[]
}

interface MiniProgramMapTicketExchangeResponse {
    access_token: string
    token_type: string
    expires_in: number
}

interface MiniProgramDistributionEnvelope {
    distribution: DeviceDistributionResponse
}

const miniProgramMapApi = axios.create({
    baseURL: resolveApiBaseUrl(),
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
})

const joinListParam = (values?: Array<number | string>): string | undefined => (
    values && values.length > 0 ? values.join(',') : undefined
)

export const exchangeMiniProgramMapTicket = async (
    ticket: string
): Promise<string> => {
    const response = await miniProgramMapApi.post<MiniProgramMapTicketExchangeResponse>(
        '/client-uniapp/map-ticket/exchange',
        { ticket }
    )
    return response.data.access_token
}

export const getMiniProgramMapDistribution = async (
    query: MiniProgramMapDistributionQuery,
    accessToken?: string
): Promise<DeviceDistributionResponse> => {
    const response = await miniProgramMapApi.get<MiniProgramDistributionEnvelope>(
        '/client-uniapp/distribution',
        {
            headers: accessToken
                ? { Authorization: `Bearer ${accessToken}` }
                : undefined,
            params: {
                minLng: query.minLng,
                maxLng: query.maxLng,
                minLat: query.minLat,
                maxLat: query.maxLat,
                zoom: query.zoom,
                maxVisibleDevices: query.maxVisibleDevices,
                projectIds: joinListParam(query.projectIds),
                regionIds: joinListParam(query.regionIds),
                deviceIds: joinListParam(query.deviceIds),
                pestTypes: joinListParam(query.pestTypes),
            },
        }
    )
    return response.data.distribution
}
